// API基础URL配置
// 从环境变量中获取API URL，如果未定义则使用默认值
export const getApiUrl = (): string => {
  return process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
};

// 获取应用程序环境
export const getAppEnvironment = (): string => {
  return process.env.NODE_ENV || 'development';
};

// 是否为生产环境
export const isProduction = (): boolean => {
  return getAppEnvironment() === 'production';
};

// 是否为开发环境
export const isDevelopment = (): boolean => {
  return getAppEnvironment() === 'development';
}; 